import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { Fighter } from '../../../../../../corelogic/domain/models/fighter.model';
import { capitalizeFirstLetter } from '../../../../../../corelogic/domain/utils/capitalize.utils';
import { getWeightDisplayName } from '../../../../../../corelogic/domain/utils/weightUtils';

const styles = {
  fighterCardFavorite: {
    p: 1,
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '64px',
    width: '100%',
    mb: 0.5,
    transition: 'all 0.2s',
    border: '1px solid rgba(204, 0, 0, 0.3)',
    bgcolor: 'rgba(204, 0, 0, 0.05)',
    '&:hover': {
      bgcolor: 'rgba(60, 60, 60, 0.8)',
    },
  },
  fighterCard: {
    p: 1,
    borderRadius: 1,
    bgcolor: 'rgba(40, 40, 40, 0.8)',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    height: '64px',
    width: '100%',
    mb: 0.5,
    transition: 'all 0.2s',
    '&:hover': {
      bgcolor: 'rgba(60, 60, 60, 0.8)',
    },
  },
  fighterName: {
    fontFamily: 'Arial',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: 'white',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(100% - 40px)',
  },
  fighterInfo: {
    fontFamily: 'Arial',
    fontSize: '0.8rem',
    color: '#cccccc',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(100% - 40px)',
  },
  favoriteButton: (isInFavorites: boolean) => ({
    minWidth: 'auto',
    color: isInFavorites ? '#cc0000' : 'rgba(255, 255, 255, 0.5)',
    '&:hover': {
      bgcolor: 'rgba(204, 0, 0, 0.1)',
    },
  }),
};

export const FighterCard = ({
  fighter,
  isFavorite,
  onClick,
  onToggleFavorite,
}: {
  fighter: Fighter;
  isFavorite: boolean;
  onClick: () => void;
  onToggleFavorite: () => void;
}) => {
  return (
    <Box
      sx={{
        ...(isFavorite ? styles.fighterCardFavorite : styles.fighterCard),
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography sx={styles.fighterName}>
          {fighter.firstname} {fighter.lastname}
        </Typography>
        <Typography sx={styles.fighterInfo}>
          {fighter.wins}-{fighter.losses}-{fighter.draws} •{' '}
          {capitalizeFirstLetter(fighter.gender)} •{' '}
          {getWeightDisplayName(fighter.weight)}
        </Typography>
      </Box>
      <Tooltip
        title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      >
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onToggleFavorite();
          }}
          sx={styles.favoriteButton(isFavorite)}
        >
          {isFavorite ? (
            <FavoriteIcon fontSize="small" />
          ) : (
            <FavoriteBorderIcon fontSize="small" />
          )}
        </Button>
      </Tooltip>
    </Box>
  );
};
